import React from 'react';
import { Button } from '../components/UI/Button';
import { Users, Lightbulb, Bot, Video, Calendar, FileText, UserPlus, Globe, Award, Clock, Check, AlertTriangle, MessageSquare } from 'lucide-react';
export const Membership = () => {
  return <div className="pt-20 bg-white" data-id="element-3188">
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-3189">
        <div className="absolute inset-0 z-0" data-id="element-3190">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3191" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3192"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3193">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3194">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-3195">
              LIMITED TIME OFFER
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3196">
              The Inner Circle Membership
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3197">
              Join The Networking Salon Inner Circle — a curated community of
              ambitious professionals. Build meaningful relationships, polish
              your ideas, and unlock opportunities.
            </p>
            <Button className="text-lg px-8 py-4" data-id="element-3198">
              Join Today for ₦20,000 (Founder's Offer)
            </Button>
          </div>
        </div>
      </section>
      {/* Announcement Section */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-3199">
        <div className="container mx-auto px-4" data-id="element-3200">
          <div className="max-w-3xl mx-auto border-2 border-dashed border-gray-400 rounded-lg p-8 text-center" data-id="element-3201">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6" data-id="element-3202">
              Special Founder's Offer
            </h2>
            <div className="flex flex-col md:flex-row justify-center gap-8 mb-6" data-id="element-3203">
              <div data-id="element-3204">
                <p className="text-lg text-gray-600 mb-2" data-id="element-3205">Regular Price:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-3206">₦50,000/year</p>
              </div>
              <div className="md:border-l md:border-gray-300 md:pl-8" data-id="element-3207">
                <p className="text-lg text-gray-600 mb-2" data-id="element-3208">Founder's Offer:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-3209">₦20,000/year</p>
                <p className="text-gray-600 italic" data-id="element-3210">(until Dec 31 only)</p>
              </div>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg" data-id="element-3211">
              <p className="text-gray-700" data-id="element-3212">
                Subscriptions officially begin Jan 1, 2025 — join now and get
                December free.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3213">
        <div className="container mx-auto px-4" data-id="element-3214">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3215">
            Membership Benefits
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-3216">
            {[{
            title: 'Mastermind Sessions',
            description: 'Live idea feedback & strategy polishing',
            icon: <Lightbulb size={24} data-id="element-3217" />
          }, {
            title: 'Project Handholding',
            description: 'Step-by-step guidance',
            icon: <Users size={24} data-id="element-3218" />
          }, {
            title: 'AI Tools Catalogue',
            description: 'Curated tools + playbooks',
            icon: <Bot size={24} data-id="element-3219" />
          }, {
            title: 'Virtual Networking Salons',
            description: 'Free & unlimited for members',
            icon: <Video size={24} data-id="element-3220" />
          }, {
            title: 'Discounted Access to Live Events',
            description: 'Special pricing for Inner Circle members',
            icon: <Calendar size={24} data-id="element-3221" />
          }, {
            title: 'Exclusive Resource Hub',
            description: 'Templates & toolkits',
            icon: <FileText size={24} data-id="element-3222" />
          }, {
            title: 'Mentorship & Expert Access',
            description: 'Group coaching & hot-seat sessions',
            icon: <UserPlus size={24} data-id="element-3223" />
          }, {
            title: 'Visibility & Collaboration Opportunities',
            description: 'Connect with other members',
            icon: <Globe size={24} data-id="element-3224" />
          }].map((benefit, index) => <div key={index} className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-3225">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-3226">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-3227">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-3228">{benefit.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Community Structure */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-3229">
        <div className="container mx-auto px-4" data-id="element-3230">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3231">
            Event & Community Structure
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-3232">
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3233">
              <div className="flex items-center mb-4" data-id="element-3234">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-3235">
                  <MessageSquare size={24} data-id="element-3236" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3237">
                  WhatsApp Groups
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-3238">
                <p className="text-gray-600 mb-4" data-id="element-3239">
                  Reserved exclusively for physical event attendees only.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-3240">
                  <li data-id="element-3241">Event-specific discussions</li>
                  <li data-id="element-3242">Limited-time access</li>
                  <li data-id="element-3243">City-based connections</li>
                </ul>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3244">
              <div className="flex items-center mb-4" data-id="element-3245">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-3246">
                  <Users size={24} data-id="element-3247" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3248">
                  Inner Circle Membership
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-3249">
                <p className="text-gray-600 mb-4" data-id="element-3250">
                  Ongoing access to our premium community resources.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-3251">
                  <li data-id="element-3252">Regular masterminds</li>
                  <li data-id="element-3253">Virtual salons</li>
                  <li data-id="element-3254">Exclusive resources</li>
                  <li data-id="element-3255">Ongoing opportunities</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Lifetime Access */}
      <section className="py-16 border-b border-gray-200" data-id="element-3256">
        <div className="container mx-auto px-4" data-id="element-3257">
          <div className="max-w-3xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-3258">
            <div className="flex items-center justify-center mb-6" data-id="element-3259">
              <Award size={36} className="text-gray-700 mr-3" data-id="element-3260" />
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800" data-id="element-3261">
                Lifetime Access Notice
              </h2>
            </div>
            <p className="text-gray-600 text-lg text-center mb-6" data-id="element-3262">
              As a thank-you, everyone who has ever paid for past Networking
              Salon events now has Lifetime Inner Circle Access — which includes
              all membership benefits (masterminds, resources, AI tools, and
              virtual salons).
            </p>
            <div className="flex items-start bg-gray-100 p-4 rounded-lg border border-gray-300" data-id="element-3263">
              <AlertTriangle size={24} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-3264" />
              <p className="text-gray-700" data-id="element-3265">
                <span className="font-bold" data-id="element-3266">Clarification:</span> Lifetime
                Access does not include free entry to Live physical events.
                Tickets must still be purchased separately.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3267">
        <div className="container mx-auto px-4" data-id="element-3268">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3269">
            Choose Your Membership
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-3270">
            {/* Lifetime Inner Circle Access */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-3271">
              <div className="absolute top-0 right-0 bg-gray-800 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-3272">
                EXCLUSIVE
              </div>
              <div className="flex justify-center mb-6" data-id="element-3273">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-3274">
                  <Award size={32} className="text-gray-700" data-id="element-3275" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-3276">
                Lifetime Inner Circle Access
              </h3>
              <p className="text-center text-gray-600 mb-6" data-id="element-3277">
                💎 Exclusive for Past Event Attendees
              </p>
              <div className="border-t border-b border-gray-300 py-4 mb-6" data-id="element-3278">
                <p className="text-center text-gray-700 font-medium" data-id="element-3279">
                  One-time gift for loyalty
                </p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-3280">
                <li className="flex items-start" data-id="element-3281">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3282" />
                  <span className="text-gray-600" data-id="element-3283">
                    All Inner Circle membership benefits
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3284">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3285" />
                  <span className="text-gray-600" data-id="element-3286">Masterminds & resources</span>
                </li>
                <li className="flex items-start" data-id="element-3287">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3288" />
                  <span className="text-gray-600" data-id="element-3289">
                    AI tools & virtual salons
                  </span>
                </li>
                <li className="flex items-start text-gray-700 bg-gray-100 p-2 rounded" data-id="element-3290">
                  <AlertTriangle size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3291" />
                  <span data-id="element-3292">
                    Does NOT include free entry to Live physical events
                  </span>
                </li>
              </ul>
              <div className="bg-gray-200 text-center p-3 rounded-lg mb-6" data-id="element-3293">
                <span className="font-bold text-gray-700" data-id="element-3294">
                  You're Already In!
                </span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-3295">
                Already a Lifetime Member? Claim Your Access
              </Button>
            </div>
            {/* Founder's Offer */}
            <div className="border-2 border-gray-700 rounded-lg p-8 relative scale-105 shadow-lg" data-id="element-3296">
              <div className="absolute -top-4 -right-4 bg-gray-800 text-white px-4 py-2 text-sm font-bold rounded-lg transform rotate-6" data-id="element-3297">
                BEST VALUE
              </div>
              <div className="flex justify-center mb-6" data-id="element-3298">
                <div className="w-16 h-16 border-2 border-gray-700 rounded-full flex items-center justify-center" data-id="element-3299">
                  <Clock size={32} className="text-gray-700" data-id="element-3300" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-3301">
                Founder's Offer
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-3302">
                🔥 Available Until Dec 31, 2024
              </p>
              <div className="text-center mb-6" data-id="element-3303">
                <p className="text-3xl font-bold text-gray-800" data-id="element-3304">₦20,000</p>
                <p className="text-gray-600" data-id="element-3305">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-3306">
                <li className="flex items-start" data-id="element-3307">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3308" />
                  <span className="text-gray-600" data-id="element-3309">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3310">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3311" />
                  <span className="text-gray-600" data-id="element-3312">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3313">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3314" />
                  <span className="text-gray-600" data-id="element-3315">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3316">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3317" />
                  <span className="text-gray-600" data-id="element-3318">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-3319">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3320" />
                  <span className="text-gray-600" data-id="element-3321">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6" data-id="element-3322">
                <span className="font-medium text-gray-700" data-id="element-3323">
                  Bonus: Subscription officially starts Jan 1, 2025 (December
                  free!)
                </span>
              </div>
              <Button className="w-full" data-id="element-3324">Join Now at ₦20,000</Button>
            </div>
            {/* Standard Membership */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-3325">
              <div className="absolute top-0 right-0 bg-gray-600 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-3326">
                REGULAR PRICE
              </div>
              <div className="flex justify-center mb-6" data-id="element-3327">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-3328">
                  <Users size={32} className="text-gray-700" data-id="element-3329" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-3330">
                Standard Membership
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-3331">
                📌 From Jan 1, 2025
              </p>
              <div className="text-center mb-6" data-id="element-3332">
                <p className="text-3xl font-bold text-gray-800" data-id="element-3333">₦50,000</p>
                <p className="text-gray-600" data-id="element-3334">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-3335">
                <li className="flex items-start" data-id="element-3336">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3337" />
                  <span className="text-gray-600" data-id="element-3338">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3339">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3340" />
                  <span className="text-gray-600" data-id="element-3341">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3342">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3343" />
                  <span className="text-gray-600" data-id="element-3344">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3345">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3346" />
                  <span className="text-gray-600" data-id="element-3347">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-3348">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3349" />
                  <span className="text-gray-600" data-id="element-3350">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6 invisible" data-id="element-3351">
                <span data-id="element-3352">Spacer</span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-3353">
                Join for ₦50,000
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-20 bg-gray-50" data-id="element-3354">
        <div className="container mx-auto px-4 text-center" data-id="element-3355">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto" data-id="element-3356">
            Stop Collecting Contacts. Start Building Connections That Change
            Your Future.
          </h2>
          <Button className="text-lg px-8 py-4" data-id="element-3357">
            Join Now for ₦20,000 (Founder's Rate)
          </Button>
          <p className="mt-6 text-gray-600" data-id="element-3358">
            Offer ends December 31, 2024. Regular price ₦50,000/year from
            January 1, 2025.
          </p>
        </div>
      </section>
    </div>;
};